





























import { Component, Prop, Vue } from "vue-property-decorator";
import ContentRenderComponent from "@/components/render/ContentRender.vue";
import { RenderTemplateModel, RenderContentModel } from "@/services/render/types";
import { renderBackground } from "@/services/render/renderService";
import { Getter } from "vuex-class";
import PreviewModalHeader from "@/components/common/preview/PreviewModalHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";
const namespace: string = "authentication";

@Component({
    components: {
        ContentRenderComponent,
        PreviewModalHeader,
        PreviewSidebar
    }
})
export default class BackgroundPreviewModal extends Vue {
    @Getter("getToken", { namespace }) getToken!: string;

    // local state
    backgroundId = "";
    contentRenderModel = {
        height: 0,
        width: 0,
        renderChannels: [] as Array<RenderContentModel>
    } as RenderTemplateModel;

    contentRenderReload = 0;
    scale = 1;
    dateTime = "";
    fitScale = 0;
    bgColor = "#ffffff";
    name = "";
    allowTransition = false;

    open(backgroundId: string, name: string) {
        this.allowTransition = false;
        this.backgroundId = backgroundId;
        this.name = name;
        this.$bvModal.show("modal-backgroundPreview");
    }

    hide() {
        this.$bvModal.hide("modal-backgroundPreview");
    }

    renderBackground(value: string, keepZoom = false) {
        this.dateTime = value;
        renderBackground(this.backgroundId, this.dateTime).then(
            response => {
                this.contentRenderModel = response;
                const oldScale = this.scale;
                this.setScale();
                if (keepZoom) this.scale = oldScale;
            }
        );
    }

    onScale(value: number) {
        this.scale = value;
        this.allowTransition = true;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    fullScreen() {
        return { name: "backgroundpreview", params: { backgroundId: this.backgroundId } };
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 70) / this.contentRenderModel.width;
        var scaleY = (window.innerHeight / 100 * 74) / this.contentRenderModel.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    // computed
    get model(): RenderTemplateModel {
        this.contentRenderReload += 1;
        return this.contentRenderModel;
    }

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.contentRenderModel.height}px`,
            width: `${this.contentRenderModel.width}px`
        };
    }
}
